import { ContactBasicModel } from "../data";

export interface ContactsBasicPayloadModel {
  contacts: ContactBasicModel[];
}
